import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import ContactInfo from "../../components/pages/WriteToUs/ContactInfo/ContactInfo";

const WriteToUsPage: React.FC = () => {
  return (
    <Layout>
      <ContactInfo />
      <Feedback />
    </Layout>
  );
};

export default WriteToUsPage;
